// pp-to-properties.js — robust line item properties for Ride (updated)
(function () {
  const KEYS = [
    'Package Price','Service Fees Due Today','Plan Fee Due Today',
    'Number of Payments','Monthly Payment Amount','1st Payment Due',
    'Balance Due Date','Balance due in' // keep this synchronized with buildProps
  ];

  const q  = (s, r) => (r||document).querySelector(s);
  const qa = (s, r) => Array.from((r||document).querySelectorAll(s));

  function moneyNoCents(cents){
    const cur = (window.PP && window.PP.currencyCode) || 'USD';
    const n = Number(cents) || 0;
    return new Intl.NumberFormat(undefined, {
      style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(n / 100);
  }
  function moneyWithCents(cents){
    const cur = (window.PP && window.PP.currencyCode) || 'USD';
    const n = Number(cents) || 0;
    return new Intl.NumberFormat(undefined, {
      style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(n / 100);
  }
  function fmtDate(d){
    try { return new Intl.DateTimeFormat(undefined,{month:'short',day:'numeric',year:'numeric'}).format(d); }
    catch(_){ return d.toISOString().slice(0,10); }
  }
  function addDays(date, days){
    const d = new Date(date.getTime());
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  }

  // ---- Month math (ceil) to prevent off-by-one drift ----
  function daysInMonth(y, m){ return new Date(y, m + 1, 0).getDate(); }
  function addMonthsSafe(date, months){
    const y = date.getFullYear();
    const m = date.getMonth() + months;
    const d = Math.min(date.getDate(), daysInMonth(y, m));
    return new Date(y, m, d);
  }
  // Counts how many whole/partial months from "from" to "to" (ceil).
  function monthsBetweenCeil(from, to){
    let months = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
    const anchor = addMonthsSafe(from, months);
    if (to > anchor) months += 1; // only add if there's a partial month remaining
    return Math.max(1, months);
  }

  // Human-friendly relative text for "Balance due in"
  function relText(days){
    const d = Number(days) || 0;
    if (d % 7 === 0 && d !== 0) {
      const w = d / 7;
      return `${w} week${w === 1 ? '' : 's'}`;
    }
    return `${d} day${d === 1 ? '' : 's'}`;
  }

  function currentVariantId(form){
    const hid = form?.querySelector('input[name="id"]');
    if (hid?.value) return String(hid.value);
    const sel = form?.querySelector('select[name="id"]') || q('select[name="id"]');
    if (sel?.value) return String(sel.value);
    return null;
  }
  function getVD(id){
    return id && window.PP && window.PP.variantData ? window.PP.variantData[id] : null;
  }

  function clearManagedProps(form){
    qa('input[name^="properties["]', form).forEach(input => {
      const name = input.getAttribute('name') || '';
      const key = name.replace(/^properties\[|\]$/g,'');
      if (KEYS.includes(key)) input.remove();
    });
  }
  function ensureProp(form, key, value){
    if (value == null || String(value).trim() === '') return;
    let input = form.querySelector(`input[name="properties[${key}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      form.appendChild(input);
    }
    input.value = String(value);
  }

  function buildProps(vd){
    const rows = []; // ordered [key, value] tuples

    // Always include first (no cents)
    rows.push(['Package Price', moneyNoCents(vd.packageCents || 0)]);
    rows.push(['Service Fees Due Today', moneyNoCents(vd.serviceFeeCents || 0)]);

    // Flags set by Liquid
    const isPlan      = !!vd.isPlan;
    const isPayInFull = !!vd.isPayInFull;

    // Dates & offsets
    const now             = new Date();
    const firstOffset     = Number(window.PP?.firstPaymentOffsetDays || 14);
    const payFullOffset   = Number(window.PP?.payFullBalanceOffsetDays || 7);
    const firstPaymentDate = addDays(now, firstOffset);
    const balanceDueDate   = addDays(now, payFullOffset);

    // Delivery date (end) & number of payments
    const deliveryISO = window.PP?.deliveryDateISO || null;
    let num = null;

    // If PDP precomputed the number, trust it for guaranteed parity.
    if (typeof window.PP?.numPayments === 'number' && window.PP.numPayments > 0) {
      num = Math.max(1, Math.floor(window.PP.numPayments));
    } else if (deliveryISO) {
      const delivery = new Date(deliveryISO + 'T00:00:00');
      if (!isNaN(delivery)) {
        // Plans count from the first payment date to match PDP/pp-fill behavior.
        const start = isPlan ? firstPaymentDate : now;
        num = monthsBetweenCeil(start, delivery);
      }
    }

    if (isPlan) {
      const planFee = Number(vd.planFeeCents || 0);

      // 👇 Order to taste
      if (planFee > 0) rows.push(['Plan Fee Due Today', moneyNoCents(planFee)]);
      if (num != null) {
        rows.push(['Number of Payments', String(num)]);
        const perMonthCents = Math.ceil((vd.packageCents || 0) / num);
        rows.push(['Monthly Payment Amount', moneyWithCents(perMonthCents)]);
      }
      rows.push(['1st Payment Due', fmtDate(firstPaymentDate)]);

    } else if (isPayInFull) {
      // 👇 Pay-in-full block; include relative and absolute
      rows.push(['Balance due in', relText(payFullOffset)]);
      rows.push(['Balance Due Date', fmtDate(balanceDueDate)]);
    }

    return rows;
  }

  function sync(form){
    try {
      if (!form || !window.PP || !window.PP.variantData) return;
      const id = currentVariantId(form);
      const vd = getVD(id);
      if (!vd) return;

      clearManagedProps(form);
      const list = buildProps(vd); // ordered array of [key, value]
      list.forEach(([k, v]) => ensureProp(form, k, v));
    } catch (e) {
      console.error('[pp-to-properties] sync error', e);
    }
  }

  function attach(form){
    if (!form || form.__ppPropsAttached) return;
    form.__ppPropsAttached = true;

    sync(form);

    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      new MutationObserver(() => sync(form)).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      idInput.addEventListener('input',  () => sync(form));
      idInput.addEventListener('change', () => sync(form));
    }
    const sel = form.querySelector('select[name="id"]');
    if (sel) sel.addEventListener('change', () => sync(form));
    qa('input[name^="options["]', form).forEach(r => r.addEventListener('change', () => sync(form)));
    document.addEventListener('variant:change', () => sync(form));

    const wrap = form.closest('product-form') || form.parentElement || document;
    const btns = qa('.shopify-payment-button__button, .shopify-payment-button__more-options', wrap);
    btns.forEach(btn => {
      ['pointerdown','click'].forEach(evt => {
        // capture = early
        btn.addEventListener(evt, () => sync(form), { capture: true });
        // bubble = last pass
        btn.addEventListener(evt, () => sync(form));
      });
    });

    // And on normal submit
    form.addEventListener('submit', () => sync(form), { capture: true });
  }

  qa('form[action*="/cart/add"]').forEach(attach);
})();
